import apiSlice from "./ApiSlice";

export const expensesApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Get
    getExpenses: builder.query({
      providesTags: ["expence"],
      query: (body) => {
        return {
          url: "/expence",
          method: "POST",
          body,
        };
      },
    }),

    // ADD
    addExpenses: builder.mutation({
      invalidatesTags: ["expence"],
      query: (body) => {
        return {
          url: "/expence/add",
          method: "POST",
          body,
        };
      },
    }),
    // EDIT
    editExpense: builder.mutation({
      invalidatesTags: ["expence"],
      query: ({ body, id }: any) => {
        return {
          url: `/expence/${id}`,
          method: 'PUT',
          body
        };
      },
    }),

    //Single View
    viewExpenseById: builder.query({
      providesTags: ["expence"],
      query: (id: any) => {
        return {
          url: `/expence/${id}`,
          method: "GET",
        };
      },
    }),

  }),
});

export const { useGetExpensesQuery, useAddExpensesMutation, useViewExpenseByIdQuery, useEditExpenseMutation } = expensesApi;
